import { onFID } from 'web-vitals';

const longtasks = (trackPerformanceMetricEvent) => {
  onFID(function longtasksMetricsFID() {
    if ('PerformanceLongTaskTiming' in window) {
      const po = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        const cumulative_longtask_count = entries.length;

        const cumulative_blocking_time = entries.reduce(
          /**
           * Subtract 50 milliseconds because the blocking time of any given long task is considered
           * its duration in excess of 50 ms.
           */
          (blocking_time, { duration }) => blocking_time + duration - 50,
          0 // default blocking_time
        );

        // Test if there are long tasks before proceeding
        if (cumulative_longtask_count) {
          trackPerformanceMetricEvent({
            metric_name: 'cumulative-longtask-count',
            metric_type: 'custom',
            metric_value: cumulative_longtask_count,
          });

          trackPerformanceMetricEvent({
            metric_name: 'cumulative-blocking-time',
            metric_type: 'custom',
            metric_value: cumulative_blocking_time,
          });
        }

        po.disconnect();
      });

      po.observe({type: 'longtask', buffered: true});
    }
  });
};

export default longtasks;
